import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Nav, Navbar, NavItem } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import styled from 'styled-components'

const StyledNavbar = styled(Navbar)`
  min-height: 80px;
  height: 80px;
`

const StyledNavbarHeader = styled(Navbar.Header)`
  margin: 12px;
`

const StyledNavbarBrand = styled(Navbar.Brand)`
  padding: 0 15px;
  height: 80px;
  line-height: 80px;
`

const StyledNavbarToggle = styled(Navbar.Toggle)`
  margin-top: 23px;
  padding: 9px 10px !important;
`

const StyledNav = styled(Nav)`
  margin-top: 15px;
  text-align: right;
  @media (min-width: 768px) {
    .navbar-nav > li > a {
      padding-top: 26.5px;
      padding-bottom: 26.5px;
      line-height: 27px;
    }
  }
`

const Image = styled.img`
  max-width: 150px;
  max-height: 70px;
`

function TopMenu({ authenticatedUser, handleLogout }) {
  return (
    <StyledNavbar fluid collapseOnSelect>
      <StyledNavbarHeader>
        <StyledNavbarBrand>
          <Link to="/"><Image src="/logo.png" /></Link>
        </StyledNavbarBrand>
        <StyledNavbarToggle />
      </StyledNavbarHeader>
      <Navbar.Collapse>
        <StyledNav pullRight>
          {authenticatedUser
            ? <div>
                {authenticatedUser}
                <NavItem onClick={handleLogout}>Sair do Sistema</NavItem>
              </div>
            : <Fragment>
                <LinkContainer to="/login">
                  <NavItem>Login</NavItem>
                </LinkContainer>
                <LinkContainer to="/forgotPassword">
                  <NavItem>Recuperar senha</NavItem>
                </LinkContainer>                
            </Fragment>
          }
        </StyledNav>
      </Navbar.Collapse>
    </StyledNavbar>
  )
}

TopMenu.propTypes = {
  isAuthenticated: PropTypes.bool,
  handleLogout: PropTypes.func.isRequired
}

export default TopMenu
